import {NgModule, LOCALE_ID, DEFAULT_CURRENCY_CODE} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {CommonModule, registerLocaleData, DatePipe, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './components/header/header.component';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {FooterComponent} from './components/footer/footer.component';
import {ModalComponent} from './components/modal/modal.component';
import {AccountComponent} from "./components/account/account.component";
import {InterceptorService} from './services/interceptor.service';
import {ErrorComponent} from './pages/error/error.component';
import {LoginComponent} from './pages/login/login.component';
import {CreateAccountComponent} from './pages/create-account/create-account.component';
import {MyAccountComponent} from './pages/my-account/my-account.component';
import {QuestionComponent} from './pages/question/question.component';
import {RadioInlineComponent} from './components/question-types/radio-inline/radio-inline.component';
import {CheckboxComponent} from './components/question-types/checkbox/checkbox.component';
import {LogosUnloggedComponent} from './components/logos-unlogged/logos-unlogged.component';
import {PasswordResetComponent} from './pages/password-reset/password-reset.component';
import {PasswordReminderComponent} from './pages/password-reminder/password-reminder.component';
import {ModuleIntroComponent} from './pages/module-intro/module-intro.component';
import {ModuleExplanationComponent} from './pages/module-explanation/module-explanation.component';
import {ModulesListComponent} from './pages/modules-list/modules-list.component';
import {DropzoneSingleComponent} from './components/question-types/dropzone-single/dropzone-single.component';
import {DropzoneMultipleComponent} from './components/question-types/dropzone-multiple/dropzone-multiple.component';
import { SmallTextsComponent } from './components/small-texts/small-texts.component';
import { ModuleEndComponent } from './pages/module-end/module-end.component';
import { RadioComponent } from './components/question-types/radio/radio.component';
import { AsterisksComponent } from './components/asterisks/asterisks.component';
import { AnnexesComponent } from './components/annexes/annexes.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    ModalComponent,
    AccountComponent,
    ErrorComponent,
    LoginComponent,
    CreateAccountComponent,
    MyAccountComponent,
    QuestionComponent,
    RadioInlineComponent,
    CheckboxComponent,
    LogosUnloggedComponent,
    PasswordResetComponent,
    PasswordReminderComponent,
    ModuleIntroComponent,
    ModuleExplanationComponent,
    ModulesListComponent,
    DropzoneSingleComponent,
    DropzoneMultipleComponent,
    SmallTextsComponent,
    ModuleEndComponent,
    RadioComponent,
    AsterisksComponent,
    AnnexesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
